import { createAxiosServiceInstance } from '../api';

const axios = createAxiosServiceInstance();
const mockBackend = 'https://private-58541-ams11.apiary-mock.com';
const headers = {
  'Content-Type': 'application/json'
};

export async function getSupervisorDashboard() {
  let url = `${mockBackend}/supervisor_dashboard_data`;
  return await axios.get(url, { headers });
}
